/**
 * Converts a numeric value assumed to be in Tailwind units to `px` (returns a string containing the `px` unit, unless `asNumber` is `true`).
 */

export default (valueInTwUnits, asNumber = false) =>
  asNumber ? valueInTwUnits * 4 : `${valueInTwUnits * 4}px`
